import { z } from 'zod';

type SupportSchemaProps = {
  required: string;
  invalidEmail: string;
};

export const getSupportSchema = ({ required, invalidEmail }: SupportSchemaProps) =>
  z.object({
    name: z.string().min(1, { message: required }),
    email: z.string().min(1, { message: required }).email({ message: invalidEmail }),
    issueType: z.string().min(1, { message: required }),
    comment: z.string().min(10, { message: 'Please provide at least 10 characters for your comment' }),
  });

export type SupportSchema = z.infer<ReturnType<typeof getSupportSchema>>;

export interface BrowserInfo {
  userAgent: string;
  platform: string;
  language: string;
  cookieEnabled: boolean;
  onLine: boolean;
  screenResolution: string;
  viewportSize: string;
  timezone: string;
  timestamp: string;
  url: string;
  referrer: string;
}
